/* eslint-disable no-case-declarations */

import {
  LOADING_DISTRIBUTORS,
  LOADING_DISTRIBUTORS_SUCCESS,
  LOADING_DISTRIBUTORS_ERROR,

  ADDING_DISTRIBUTOR,
  ADDING_DISTRIBUTOR_SUCCESS,
  ADDING_DISTRIBUTOR_ERROR,

  UPDATING_DISTRIBUTOR,
  UPDATING_DISTRIBUTOR_SUCCESS,
  UPDATING_DISTRIBUTOR_ERROR,

  DELETING_DISTRIBUTOR,
  DELETING_DISTRIBUTOR_SUCCESS,
  DELETING_DISTRIBUTOR_ERROR,

  FINDING_DISTRIBUTORS,
  FINDING_DISTRIBUTORS_SUCCESS,
  FINDING_DISTRIBUTORS_ERROR,



  LOADING_COMPANIES,
  LOADING_COMPANIES_SUCCESS,
  LOADING_COMPANIES_ERROR,

  ADDING_COMPANY,
  ADDING_COMPANY_SUCCESS,
  ADDING_COMPANY_ERROR,

  UPDATING_COMPANY,
  UPDATING_COMPANY_SUCCESS,
  UPDATING_COMPANY_ERROR,

  DELETING_COMPANY,
  DELETING_COMPANY_SUCCESS,
  DELETING_COMPANY_ERROR,

  LOADING_COMPANY_NAMES,
  LOADING_COMPANY_NAMES_SUCCESS,
  LOADING_COMPANY_NAMES_ERROR,

  FINDING_COMPANIES,
  FINDING_COMPANIES_SUCCESS,
  FINDING_COMPANIES_ERROR,




  LOADING_CARS,
  LOADING_CARS_SUCCESS,
  LOADING_CARS_ERROR,

  ADDING_CAR,
  ADDING_CAR_SUCCESS,
  ADDING_CAR_ERROR,

  UPDATING_CAR,
  UPDATING_CAR_SUCCESS,
  UPDATING_CAR_ERROR,

  DELETING_CAR,
  DELETING_CAR_SUCCESS,
  DELETING_CAR_ERROR,

  LOADING_CAR_NUMBERS,
  LOADING_CAR_NUMBERS_SUCCESS,
  LOADING_CAR_NUMBERS_ERROR,

  FINDING_CARS,
  FINDING_CARS_SUCCESS,
  FINDING_CARS_ERROR,



  LOADING_AGENCIES,
  LOADING_AGENCIES_SUCCESS,
  LOADING_AGENCIES_ERROR,

  ADDING_AGENCY,
  ADDING_AGENCY_SUCCESS,
  ADDING_AGENCY_ERROR,

  UPDATING_AGENCY,
  UPDATING_AGENCY_SUCCESS,
  UPDATING_AGENCY_ERROR,

  DELETING_AGENCY,
  DELETING_AGENCY_SUCCESS,
  DELETING_AGENCY_ERROR,

  FINDING_AGENCIES,
  FINDING_AGENCIES_SUCCESS,
  FINDING_AGENCIES_ERROR,



  LOADING_CLIENTS,
  LOADING_CLIENTS_SUCCESS,
  LOADING_CLIENTS_ERROR,

  ADDING_CLIENT,
  ADDING_CLIENT_SUCCESS,
  ADDING_CLIENT_ERROR,

  UPDATING_CLIENT,
  UPDATING_CLIENT_SUCCESS,
  UPDATING_CLIENT_ERROR,

  DELETING_CLIENT,
  DELETING_CLIENT_SUCCESS,
  DELETING_CLIENT_ERROR,

  FINDING_CLIENTS,
  FINDING_CLIENTS_SUCCESS,
  FINDING_CLIENTS_ERROR,
} from '../actions/companies';

const initialState = {
  distributorList: [],
  distributor_total: 0,
  find_distributor_loading: false,

  companyNameList: [],
  companyList: [],
  company_total: 0,
  find_company_loading: false,

  carNumberList: [],
  carList: [],
  car_total: 0,
  find_car_loading: false,

  reged_agencyList: [],
  agencyList: [],
  agency_total: 0,
  find_agency_loading: false,

  reged_clientList: [],
  clientList: [],
  client_total: 0,
  find_client_loading: false,

  loading: false,
};
  
const CompaniesReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADING_DISTRIBUTORS:
        return { ...state, loading: true };
  
      case LOADING_DISTRIBUTORS_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          distributorList: action.payload,
        };

      case ADDING_DISTRIBUTOR:
        return { ...state, loading: true };
  
      case ADDING_DISTRIBUTOR_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          //distributorList: [...state.distributorList, action.payload],
          distributorList: [action.payload],
          distributor_total: 1,
        };

      case UPDATING_DISTRIBUTOR:
        return { ...state, loading: true };
  
      case UPDATING_DISTRIBUTOR_SUCCESS:
        const distributor = action.payload;
        const newDistributors = state.distributorList.map((obj) => {
          return distributor.id === obj.id ? distributor : obj;
        });
        return {
          ...state,
          loading: false,
          distributorList: [...newDistributors]
        };

      case DELETING_DISTRIBUTOR:
        return { ...state, loading: true };
  
      case DELETING_DISTRIBUTOR_SUCCESS:
        return {
          ...state,
          loading: false,
          distributorList: [...state.distributorList.filter((obj) => {
            const findObj = action.payload.find(removedDistributor => (removedDistributor.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case FINDING_DISTRIBUTORS:
        return { ...state, find_distributor_loading: true };
      case FINDING_DISTRIBUTORS_SUCCESS:
        return {
          ...state,
          find_distributor_loading: false,
          distributorList: action.payload.find_distributors,
          distributor_total: action.payload.find_total
        };


      case LOADING_COMPANIES:
        return { ...state, loading: true };
  
      case LOADING_COMPANIES_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          companyList: action.payload,
          //company_total: 1,
        };

      case ADDING_COMPANY:
        return { ...state, loading: true };
  
      case ADDING_COMPANY_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          //companyList: [...state.companyList, action.payload],
          companyList: [action.payload],
          company_total: 1,
        };

      case UPDATING_COMPANY:
        return { ...state, loading: true };
  
      case UPDATING_COMPANY_SUCCESS:
        const company = action.payload;
        const newCompanies = state.companyList.map((obj) => {
          return company.id === obj.id ? company : obj;
        });
        return {
          ...state,
          loading: false,
          companyList: [...newCompanies]
        };

      case DELETING_COMPANY:
        return { ...state, loading: true };
  
      case DELETING_COMPANY_SUCCESS:
        return {
          ...state,
          loading: false,
          companyList: [...state.companyList.filter((obj) => {
            const findObj = action.payload.find(removedCompany => (removedCompany.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case LOADING_COMPANY_NAMES:
        return { ...state, loading: true };
  
      case LOADING_COMPANY_NAMES_SUCCESS:
        return {
          ...state,
          loading: false,
          companyNameList: action.payload,
        };

      case FINDING_COMPANIES:
        return { ...state, find_company_loading: true };
      case FINDING_COMPANIES_SUCCESS:
        return {
          ...state,
          find_company_loading: false,
          companyList: action.payload.find_companies,
          company_total: action.payload.find_total
        };



      case LOADING_CARS:
        return { ...state, loading: true };
  
      case LOADING_CARS_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          carList: action.payload,
        };

      case ADDING_CAR:
        return { ...state, loading: true };
  
      case ADDING_CAR_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          //carList: [...state.carList, action.payload],
          carList: [action.payload],
          car_total: 1,
        };

      case UPDATING_CAR:
        return { ...state, loading: true };
  
      case UPDATING_CAR_SUCCESS:
        return {
          ...state,
          loading: false,
          carList: [...state.carList.map((obj) => {
            return action.payload.id === obj.id ? action.payload : obj;
          })]
        };

      case DELETING_CAR:
        return { ...state, loading: true };
  
      case DELETING_CAR_SUCCESS:
        return {
          ...state,
          loading: false,
          carList: [...state.carList.filter((obj) => {
            const findObj = action.payload.find(removedCar => (removedCar.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case LOADING_CAR_NUMBERS:
        return { ...state, loading: true };
  
      case LOADING_CAR_NUMBERS_SUCCESS:
        return {
          ...state,
          loading: false,
          carNumberList: action.payload,
        };

      case FINDING_CARS:
        return { ...state, find_car_loading: true };
      case FINDING_CARS_SUCCESS:
        return {
          ...state,
          find_car_loading: false,
          carList: action.payload.find_cars,
          car_total: action.payload.find_total
        };



      case LOADING_AGENCIES:
        return { ...state, loading: false };
  
      case LOADING_AGENCIES_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          reged_agencyList: action.payload,
        };

      case ADDING_AGENCY:
        return { ...state, loading: true };
  
      case ADDING_AGENCY_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          //agencyList: [...state.agencyList, action.payload],
          agencyList: [action.payload],
          agency_total: 1,
        };

      case UPDATING_AGENCY:
        return { ...state, loading: true };
  
      case UPDATING_AGENCY_SUCCESS:
        return {
          ...state,
          loading: false,
          agencyList: [...state.agencyList.map((obj) => {
            return action.payload.id === obj.id ? action.payload : obj;
          })]
        };

      case DELETING_AGENCY:
        return { ...state, loading: true };
  
      case DELETING_AGENCY_SUCCESS:
        return {
          ...state,
          loading: false,
          agencyList: [...state.agencyList.filter((obj) => {
            const findObj = action.payload.find(removedAgency => (removedAgency.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case FINDING_AGENCIES:
        return { ...state, find_agency_loading: true };
      case FINDING_AGENCIES_SUCCESS:
        return {
          ...state,
          find_agency_loading: false,
          agencyList: action.payload.find_agencies,
          agency_total: action.payload.find_total
        };



      case LOADING_CLIENTS:
        return { ...state, loading: true };
  
      case LOADING_CLIENTS_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          reged_clientList: action.payload,
        };

      case ADDING_CLIENT:
        return { ...state, loading: true };
  
      case ADDING_CLIENT_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          //clientList: [...state.clientList, action.payload],
          clientList: [action.payload],
          client_total: 1,
        };

      case UPDATING_CLIENT:
        return { ...state, loading: true };
  
      case UPDATING_CLIENT_SUCCESS:
        return {
          ...state,
          loading: false,
          clientList: [...state.clientList.map((obj) => {
            return action.payload.id === obj.id ? action.payload : obj;
          })]
        };

      case DELETING_CLIENT:
        return { ...state, loading: true };
  
      case DELETING_CLIENT_SUCCESS:
        return {
          ...state,
          loading: false,
          clientList: [...state.clientList.filter((obj) => {
            const findObj = action.payload.find(removedClient => (removedClient.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case FINDING_CLIENTS:
        return { ...state, find_client_loading: true };
      case FINDING_CLIENTS_SUCCESS:
        return {
          ...state,
          find_client_loading: false,
          clientList: action.payload.find_clients,
          client_total: action.payload.find_total
        };


      default:
        return state;
    }
  };
  
  export default CompaniesReducer;
  